__turbopack_context__.v({
  "content": "MergeCreditsDialog-module__cYjKEq__content",
  "footer": "MergeCreditsDialog-module__cYjKEq__footer",
  "message": "MergeCreditsDialog-module__cYjKEq__message",
});
